
import Vue from "vue"
import Component from "vue-class-component"
import {Inject} from "vue-property-decorator"
import {AuthenticationService} from "@/AuthenticationService"
import Password from "vue-password-strength-meter"
import _ from "lodash"

@Component({components: {Password}})
export default class Login extends Vue {
  @Inject()
  authenticationService: AuthenticationService

  password = ""
  confirmPassword = ""
  passwordStrengthScore = 0

  isPlainTextPassword: boolean = <any>null
  isPlainTextConfirmPassword: boolean = <any>null

  token: string | null
  isTokenInvalid = true
  message = ""
  errorMessage = "The password reset link is invalid, please request a new one."

  async created() {
    const urlSearchParameters = new URLSearchParams(location.search)
    const tokenParameter = urlSearchParameters.get("token")

    if (tokenParameter == null) {
      this.message = this.errorMessage
    } else {
      this.token = tokenParameter.split(",")[0]
      const response = await this.authenticationService.validateToken(this.token)
      if (response.status === 200) {
        this.isTokenInvalid = false
      } else {
        this.message = this.errorMessage
      }
    }
  }

  async setNewPassword(event: Event) {
    event.preventDefault()

    if (this.token === null) {
      this.message = this.errorMessage
    } else if (this.hasWhiteSpace(this.password)) {
      this.message = "Password can not contain any white space"
    } else {
      this.message = await this.authenticationService.setNewPassword(
        this.password,
        this.confirmPassword,
        this.token
      )

      if (_.isEmpty(this.message)) await this.$router.push("/")
    }
  }

  isPasswordWeak() {
    return this.passwordStrengthScore < 3
  }

  get passwordsMatch() {
    return this.password === this.confirmPassword
  }

  setPasswordStrengthScore(score: number) {
    this.passwordStrengthScore = score
  }

  hasWhiteSpace(password: string) {
    return /\s/.test(password)
  }
}
